import { createFileRoute, Navigate, useParams } from "@tanstack/react-router";
import { IssueDetail } from "@/components/issues/issue-detail/issue-detail";
import { useMediaQuery } from "@/hooks/use-media-query";

/** Same breakpoint the Issues page uses to open issues in place. */
const DESKTOP_QUERY = "(min-width: 768px)";

export const Route = createFileRoute("/projects/$projectId/issues/$issueId/")({
  component: IssueDetailPage,
});

/**
 * The issue as its own page — on phones. On desktop an issue belongs beside
 * the list, so this route hands over to the Issues page with `?issue=`, which
 * shows it as the side panel (or full view on a narrow window). That covers a
 * link from a record's issues band, a new tab, a refresh, and a phone-width
 * window widened past the breakpoint. See [[issue-detail-page.spec]].
 */
export function IssueDetailPage() {
  const { projectId, issueId } = useParams({
    from: "/projects/$projectId/issues/$issueId/",
  });
  const isDesktop = useMediaQuery(DESKTOP_QUERY);

  if (isDesktop) {
    return (
      <Navigate
        to="/projects/$projectId/issues"
        params={{ projectId }}
        search={{ issue: issueId }}
        replace
      />
    );
  }

  return <IssueDetail projectId={projectId} issueId={issueId} />;
}
